import { shipmentZonesStore } from './shipmentZonesStore' 
import { subscriptionStore } from './subscriptionStore' 
import { deliveryStore } from './deliveryStore' 
import { orderStore } from './orderStore' 

import { Subscription } from '../core/Subscription'

import { OrderApi } from '../api/OrderApi'
import { SubscriptionApi } from '../api/SubscriptionApi'

import { container } from '../services/container'
import { Repository } from '../services/Repository'

import { createToken } from 'vue-stripe-elements-plus'

export const stepPaymentStore = {
  state: {
    loading: false,

    method: 'creditCard',
    error: null,
    complete: false,
    cardElement: null,
    stripe: null,
    elements: null
  },



  config: {
    stripe: {
      options: {
        email: container.get('user') ? container.get('user').email : null,
        key: process.env.VUE_APP_STRIPE_KEY,
        appearance: {
          theme: 'stripe',
          variables: {
            colorDanger: '#fa755a',
            fontFamily: '"Open Sans", sans-serif',
          }
        }
      },
    },
    /*style: {
      theme: "night",
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: '"Open Sans", sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }*/
  },

  
  stepPayment () {
    this.state.loading = true
    
    return this.makeAgreement()
  },

  createNewSetupIntent() {


    var om = new OrderApi()
    return om.createNewSetupIntent({
      subscription_token: container.get('user').subscription.token
    }).then(response => {
      this.state.intent = response;
      return response
    })
  },
  makeAgreementStripe () {
    this.redirectTo = "check"

    if (window.location.href.includes('checkout/subscription')) {
      this.redirectTo = "check"
    }
    
    if (window.location.href.includes('checkout/subscription')) {
      this.redirectTo = "check"
    }

    if (window.location.href.includes('prova-ora')) {
      this.redirectTo = 'prova-ora'
    }

    if (window.location.href.includes('profile')) {
      this.redirectTo = "profile"
    }

    var om = new OrderApi()

    let repository = new Repository();

    let delivery = repository.getCurrentOrderDelivery();
    let address = delivery && delivery.address ? delivery.address.attributes : {
      zip_code: "20141",
      province: "MI",
      city: "Milano",
      street: "Piazza Lombardia"
    };

    console.log(address)

    return this.state.stripe.confirmSetup({
        elements: this.state.elements,
        confirmParams: {
          return_url: location.protocol+'//'+location.host + '/'+this.redirectTo+'/stripe',
          payment_method_data: {
            billing_details: {
              name: container.get('user').id + " - " +container.get('user').firstname + " " + container.get('user').lastname,
              email: container.get('user').email,
              phone: "3333333333",
              address: {
                country: "IT",
                postal_code: address.zip_code,
                state: address.province,
                city: address.city,
                line1: address.street,
                line2: " "
              }
            },
          }
        }
      })
  },
  confirmSetupIntent(params) {
    let stripe = Stripe(stepPaymentStore.config.stripe.options.key, {locale: 'it'});

    // params.setup_intent
    return stripe.retrieveSetupIntent(params.setup_intent_client_secret).then((setupIntent) => {
      console.log(setupIntent)
      switch (setupIntent.status) {
        /*case 'succeeded': {
        case 'processing': {
        }*/

        case 'requires_payment_method': {
          throw "requires_payment_method" 
        }
      }
    }).then(response => {


      // Confirm payment intent?
      return new OrderApi().confirmSetupStripe({
        subscription_token: container.get('user').subscription.token
      })
    }).then(response => {
      container.get('services.cookies').remove('_checkout_people')
      container.get('services.cookies').remove('_checkout_meals')

      var subscription = new Subscription(response.body.data.resource)
      subscriptionStore.state.subscription = subscription

       var user = container.get('user')
      if (user) user.subscription = subscriptionStore.state.subscription
      if (user) user.order = orderStore.state.order
      container.set('user', user)

      this.state.loading = false

      return response
    }).catch(e => {

      this.state.loading = false
      console.log(e)
      throw e
    })
  },

  makeAgreementPaypal () {
    var refer = window.location.href.includes('prova-ora') ? 'prova-ora' : 'checkout'
    var orderApi = new OrderApi()
    return orderApi.askPaypal({
      redirect_url_success: location.protocol+'//'+location.host + '/' + refer +'/paypal/success',
      redirect_url_cancel: location.protocol+'//'+location.host + '/' + refer +'/paypal/cancel',
      subscription_token: subscriptionStore.state.subscription.token
    })

    .then(response => {
      window.location.href = response.body.data.redirect
    })
  },

  makeAgreement () {
    if (subscriptionStore.state.subscription.status !== 'pending') {
      return Promise.reject(new Error('subscription status error'))
    }

    if (this.state.method === 'creditCard') {
      return this.makeAgreementStripe()
    }

    if (this.state.method === 'paypal') {
      return this.makeAgreementPaypal()
    }
  } 
}